import { TeacherUsersUIProvider } from "./TeacherUsersUIContext";
import { TeacherUsersCard } from "./TeacherUsersCard";

export function TeacherUsersPage({
  history,
  userGroupId,
  userType
}) {
  return (
    <TeacherUsersUIProvider>
      <TeacherUsersCard
        history={history}
        userGroupId={userGroupId}
        userType={userType}
      />
    </TeacherUsersUIProvider>
 );
}